import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
  delay,
} from "redux-saga/effects"

import {
  deleteTracking,
  getTracking,
  getTrackings,
  postAddTracking,
  putEditTracking,
  searchTrackings,
} from "helpers/services/tracking"
import {
  ADD_TRACKING,
  DELETE_TRACKING,
  EDIT_TRACKING,
  GET_TRACKING,
  GET_TRACKINGS,
  SEARCH_TRACKINGS,
} from "./actionTypes"
import {
  getTrackingsSuccess,
  getTrackingsError,
  addTrackingSuccess,
  addTrackingError,
  deleteTrackingError,
  deleteTrackingSuccess,
  editTrackingError,
  editTrackingSuccess,
} from "./actions"
import {
  getTrackingError,
  getTrackingSuccess,
  searchTrackingsError,
  searchTrackingsSuccess,
} from "store/actions"

function* searchTrackingsOnSaga({ payload: { keyword } }) {
  try {
    const response = yield call(searchTrackings, keyword)
    yield delay(1000)
    if (response.success) {
      if (response.trackings.length > 0)
        yield put(searchTrackingsSuccess(response.trackings))
      else yield put(searchTrackingsError("Not found data."))
    } else {
      yield put(searchTrackingsError(response.message))
    }
  } catch (error) {
    yield put(searchTrackingsError(error))
  }
}

function* TrackingSearchSaga() {
  yield takeLatest(SEARCH_TRACKINGS, searchTrackingsOnSaga)
}

export default TrackingSearchSaga
